<template>
  <Component
    :is="hasItems && !isDesktop ? 'button' : 'a'"
    :href="item.link ?? undefined"
    @click="onClick"
    @keydown.space.prevent="onClick"
    @mouseenter="$emit('enter')"
    class="flex justify-between items-center w-full p-8 xl:px-4 border-gray-100 border-b-2 text-16 xl:text-14 font-bold tracking-wider hover:bg-white"
    type="button"
  >
    <span class="flex items-center text-left">
      <img v-if="item.icon?.url" class="icon-md mr-4" :src="item.icon.url" alt="" />
      {{ item.label }}
    </span>
    <svg role="presentation" focusable="false" tabindex="-1" v-if="hasItems"
      class="icon-sm text-gray-900 -rotate-90"
       
      alt=""
      svg-inline
     xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 19">
  <path fill="currentColor" fill-rule="evenodd"
    d="M.8 1.18a2.26 2.26 0 0 1 3.2 0L16 13.2 28.03 1.18a2.26 2.26 0 0 1 3.2 3.2L17.6 17.97c-.88.9-2.31.9-3.2 0L.8 4.39a2.26 2.26 0 0 1 0-3.2Z"
    clip-rule="evenodd" />
</svg>
  </Component>
</template>

<script lang="ts" setup>
import { NavigationItemClick, NavigationMenuOpen } from '@core/analytics/core-events/navigation'
import type { GQLNavigationItem } from './generated/page-header'

const props = defineProps<{
  item: GQLNavigationItem['link']
  hasItems?: boolean
  isDesktop?: boolean
}>()

const emit = defineEmits(['open', 'enter'])

const { $track } = useNuxtApp()

async function onClick() {
  if (props.hasItems) {
    emit('open')
    await $track(NavigationMenuOpen(props.item.label))
  } else {
    await $track(NavigationItemClick(props.item.link, 'header'))
  }
}
</script>
